import React from 'react';

const PageHero = ({ eyebrow, title, subtitle }) => (
  <header className="relative overflow-hidden border-b border-gold-500/10 bg-gradient-to-b from-primary-950 via-primary-900 to-stone-900 px-4 py-16 text-center text-white md:py-20">
    <div className="museum-grid absolute inset-0 opacity-30" />
    <div className="relative mx-auto max-w-3xl space-y-4">
      {eyebrow && <p className="text-xs tracking-[0.35em] text-gold-300">{eyebrow}</p>}
      <h1 className="text-3xl font-bold md:text-5xl">{title}</h1>
      {subtitle && <p className="text-base text-white/75 md:text-lg leading-relaxed">{subtitle}</p>}
    </div>
  </header>
);

export default PageHero;
